import React, { Component } from 'react';
import { Popover } from 'antd';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { langCheck } from 'Pub/js/utils';
import platform from 'Pub/js/platform';
const { pageTo } = platform;
class Knowledge extends Component {
    constructor(props) {
        super(props);
        this.dragRef = React.createRef();
        this.isDragging = false;
        this.state = {
            visible: false,
            x: null,
            y: null,
        };
    }
    // 控制popover显隐性
    handleVisibleChange = flag => {
        this.setState({ visible: flag });
    };
    // 通过知识条目进行跳转
    openKnowledge = item => {
        let { urlinfo } = item;
        if (urlinfo) {
            let { url, appcode, billid, pagecode, status, scene, nccloud_menu_name_self } = urlinfo;
            pageTo.openTo('/nccloud/resources/' + url, {
                appcode: appcode,
                billid: billid,
                pagecode: pagecode,
                status: status,
                scence: scene,
                nccloud_menu_name_self: nccloud_menu_name_self,
            });
        }
    };
    // 通过knowledgeData遍历出知识条目
    getContainer = () => {
        let { knowledgeData } = this.props;
        return (
            knowledgeData &&
            knowledgeData.length &&
            knowledgeData.map(item => {
                return (
                    <p
                        className="knowledgeItem"
                        title={item.title}
                        onClick={() => this.openKnowledge(item)}
                    >
                        {item.title}
                    </p>
                );
            })
        );
    };
    handleDragEnd = () => {
        setTimeout(() => (this.isDragging = false), 0);
        if (this.isDragging) {
            this.setState({ visible: false });
        } else {
            this.setState({ visible: true });
        }
        this.setState({
            x: this.dragRef.current.state.x,
            y: this.dragRef.current.state.y,
        });
    };

    handleClick = () => {
        if (!this.isDragging) {
            this.setState({ visible: true });
        }
    };
    render() {
        const { x, y } = this.state;
        let { knowledgeRule, knowledgeData } = this.props;
        const container = <p className="knowledgeContent">{this.getContainer()}</p>;
        const style = (x == null && y == null) ? {} : { transform: `translate(${x}px, ${y}px)` };
        return knowledgeRule && knowledgeData && knowledgeData.length ? (
            !this.state.visible ? (
                <Draggable
                    bounds="#app"
                    ref={this.dragRef}
                    position={{ x, y }}
                    onDrag={() => {
                        this.isDragging = true;
                    }}
                    onStop={this.handleDragEnd}
                >
                    <div className="avatarContainer" onClick={this.handleClick}>
                        <i className="iconfont icon-zhishiguanli" />
                    </div>
                </Draggable>
            ) : (
                <div style={{ width: 0, height: 0 }}>
                    <Popover
                        trigger="click"
                        placement="left"
                        content={container}
                        title={
                            <div>
                                {langCheck('0000PUB-000279')}
                                <span className="avatarCount">{`${knowledgeData.length}${langCheck(
                                    '0000PUB-000280',
                                )}`}</span>
                            </div>
                        }
                        visible={this.state.visible}
                        onVisibleChange={this.handleVisibleChange}
                        autoAdjustOverflow={true}
                        getPopupContainer={trigger => trigger.parentNode}
                    >
                        <div className="avatarContainer" style={style}>
                            <i className="iconfont icon-zhishiguanli" />
                        </div>
                    </Popover>
                </div>
            )
        ) : null;
    }
}
export default connect(
    state => ({
        knowledgeData: state.appData.knowledgeData,
        knowledgeRule: state.appData.knowledgeRule,
    }),
    {},
)(Knowledge);
